var map = {
	"./": 314,
	"./Live": 1127,
	"./Live.dictionary": 337,
	"./Live.dictionary.json": 337,
	"./Live.explanation": 1128,
	"./Live.explanation.ts": 1128,
	"./Live.tsx": 1127,
	"./LiveContent": 1007,
	"./LiveContent/": 1007,
	"./LiveContent/AllSportsGrid": 965,
	"./LiveContent/AllSportsGrid.js": 965,
	"./LiveContent/Announcement": 941,
	"./LiveContent/Announcement/": 941,
	"./LiveContent/Announcement/Announcement.dictionary": 895,
	"./LiveContent/Announcement/Announcement.dictionary.json": 895,
	"./LiveContent/Announcement/Announcement.module.scss": 966,
	"./LiveContent/Announcement/components/AnnouncementItem": 1030,
	"./LiveContent/Announcement/components/AnnouncementItem.tsx": 1030,
	"./LiveContent/Announcement/components/AnnouncementTable": 1086,
	"./LiveContent/Announcement/components/AnnouncementTable.tsx": 1086,
	"./LiveContent/Announcement/components/FilterByTime": 1087,
	"./LiveContent/Announcement/components/FilterByTime.tsx": 1087,
	"./LiveContent/Announcement/get-time-to-fetch-utils": 1088,
	"./LiveContent/Announcement/get-time-to-fetch-utils.ts": 1088,
	"./LiveContent/Announcement/index": 941,
	"./LiveContent/Announcement/index.tsx": 941,
	"./LiveContent/Announcement/types": 894,
	"./LiveContent/Announcement/types.ts": 894,
	"./LiveContent/Announcement/utils/get-announcements-and-options-utils": 1047,
	"./LiveContent/Announcement/utils/get-announcements-and-options-utils.spec": 1129,
	"./LiveContent/Announcement/utils/get-announcements-and-options-utils.spec.js": 1129,
	"./LiveContent/Announcement/utils/get-announcements-and-options-utils.ts": 1047,
	"./LiveContent/Announcement/utils/get-breadcrumbs-by-match-utils": 1029,
	"./LiveContent/Announcement/utils/get-breadcrumbs-by-match-utils.ts": 1029,
	"./LiveContent/LiveContent": 964,
	"./LiveContent/LiveContent.tsx": 964,
	"./LiveContent/MatchCenter": 896,
	"./LiveContent/MatchCenter/": 896,
	"./LiveContent/MatchCenter/MatchCenter.module.scss": 967,
	"./LiveContent/MatchCenter/index": 896,
	"./LiveContent/MatchCenter/index.tsx": 896,
	"./LiveContent/SportGrid": 897,
	"./LiveContent/SportGrid/": 897,
	"./LiveContent/SportGrid/SportGrid.module.scss": 968,
	"./LiveContent/SportGrid/TournamentTable": 927,
	"./LiveContent/SportGrid/TournamentTable.js": 927,
	"./LiveContent/SportGrid/index": 897,
	"./LiveContent/SportGrid/index.jsx": 897,
	"./LiveContent/StageGrid": 898,
	"./LiveContent/StageGrid/": 898,
	"./LiveContent/StageGrid/StageGrid": 876,
	"./LiveContent/StageGrid/StageGrid.module.scss": 928,
	"./LiveContent/StageGrid/StageGrid.tsx": 876,
	"./LiveContent/StageGrid/index": 898,
	"./LiveContent/StageGrid/index.ts": 898,
	"./LiveContent/StreamGrid": 899,
	"./LiveContent/StreamGrid/": 899,
	"./LiveContent/StreamGrid/index": 899,
	"./LiveContent/StreamGrid/index.ts": 899,
	"./LiveContent/components/GridHeader": 854,
	"./LiveContent/components/GridHeader.tsx": 854,
	"./LiveContent/components/SportsGrid": 862,
	"./LiveContent/components/SportsGrid.module.scss": 893,
	"./LiveContent/components/SportsGrid.tsx": 862,
	"./LiveContent/components/TournamentTable": 875,
	"./LiveContent/components/TournamentTable.js": 875,
	"./LiveContent/index": 1007,
	"./LiveContent/index.tsx": 1007,
	"./LiveDeferred": 358,
	"./LiveDeferred.tsx": 358,
	"./actions": 123,
	"./actions/": 123,
	"./actions/index": 123,
	"./actions/index.js": 123,
	"./actions/liveHub": 116,
	"./actions/liveHub.ts": 116,
	"./constants": 558,
	"./constants.ts": 558,
	"./index": 314,
	"./index.tsx": 314,
	"./reducer": 296,
	"./reducer/": 296,
	"./reducer/entities": 371,
	"./reducer/entities.ts": 371,
	"./reducer/index": 296,
	"./reducer/index.js": 296,
	"./reducer/presentation": 372,
	"./reducer/presentation.js": 372,
	"./selectors/entities": 121,
	"./selectors/entities.ts": 121,
	"./selectors/gridPresentation": 200,
	"./selectors/gridPresentation.ts": 200
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1248;
module.exports = webpackContext;